import React from 'react';
import { NavLink } from 'react-router-dom';
import logo from '../assets/logo.png';
import logoDark from '../assets/logo-dark.png';
import UserMenu from '../pages/auth/components/UserMenu';
import { useUser } from './UserContext';
import { hasAnyPermission } from '../interfaces/Permissions';
import { CLIENT_ACCOUNT_ACCESS_PERMISSIONS } from '../interfaces/Account';
import CheckPermission from './CheckPermission';
import { useTheme } from '../contexts/ThemeContext';

const MainNavBar: React.FC = () => {
  const { user } = useUser();
  const { theme } = useTheme();

  return (
    <div className="bg-gray-50 dark:bg-dm-bg h-9 hidden md:flex items-center justify-between px-4">
      <div className="items-center h-full flex">
        <img src={theme === 'dark' ? logoDark : logo} alt="Logo" className="h-full object-contain me-2" />
        <CheckPermission permissions={['CLIENT_VIEW_ALL', 'CLIENT_VIEW', 'ACTIVITY_VIEW_ALL', 'ACTIVITY_VIEW']}>
          <NavLink to={hasAnyPermission(user, ['CLIENT_VIEW_ALL', 'CLIENT_VIEW']) ? '/crm/clients' : '/crm/clients/activities'} className={({ isActive }) => (isActive || location.pathname.includes('/crm/calendar') || location.pathname.includes('/crm/dashboard') || location.pathname.includes('/crm/visit-reports') || location.pathname.includes('/crm/sedinte') ? 'active_menu_element' : 'menu_element')}><span>CRM</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['OFFER_VIEW_ALL', 'OFFER_VIEW']}>
          <NavLink to="/crm/offers" className={({ isActive }) => (isActive || location.pathname.includes('rates/index') || location.pathname.includes('/crm/newsletter') ? 'active_menu_element' : 'menu_element')}><span>Oferte</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['BOOKINGS_VIEW_ALL']}>
          <NavLink to="/bookings" className={({ isActive }) => ((isActive && !location.pathname.includes('bookings/ymlRoutes/index') && !location.pathname.includes('bookings/manifests') && !location.pathname.includes('bookings/freights')) ? 'active_menu_element' : 'menu_element')}><span>Bookinguri</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['MANIFESTS_VIEW_ALL']}>
          <NavLink to="/bookings/manifests" className={() => (location.pathname.includes('bookings/manifests') || location.pathname.includes('bookings/freights') ? 'active_menu_element' : 'menu_element')}><span>Manifeste</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['BOOKINGS_VIEW_ALL']}>
          <NavLink to="/containers" className={({ isActive }) => (isActive || location.pathname.includes('settings/containers/index') ? 'active_menu_element' : 'menu_element') }><span>Containere</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['BOOKINGS_VIEW_ALL']}>
          <NavLink to="/terminal" className={({ isActive }) => (isActive ? 'active_menu_element' : 'menu_element')}><span>Terminal</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['INVOICE_VIEW_ALL', 'INVOICE_VIEW']}>
          <NavLink to="/facturi" className={({ isActive }) => (isActive ? 'active_menu_element' : 'menu_element')}><span>Documente</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['PRICE_VIEW_ALL', 'PRICE_MANAGE_ALL']}>
          <NavLink to="/preturi" className={({ isActive }) => (isActive ? 'active_menu_element' : 'menu_element')}><span>Prețuri</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['USER_VIEW_ALL', 'ROLE_VIEW_ALL', ...CLIENT_ACCOUNT_ACCESS_PERMISSIONS]}>
          <NavLink to={hasAnyPermission(user, ['USER_VIEW_ALL']) ? '/hr' : hasAnyPermission(user, ['ROLE_VIEW_ALL']) ? '/hr/roles/index' : '/settings/accounts/index'} className={({ isActive }) => (isActive || location.pathname.includes('settings/accounts') ? 'active_menu_element' : 'menu_element')}><span>Utilizatori</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['SETTING_VIEW_ALL']}>
          <NavLink to="/settings" className={({ isActive }) => ((isActive && !location.pathname.includes('settings/containers/index') && !location.pathname.includes('settings/accounts')) || location.pathname.includes('bookings/ymlRoutes/index') || location.pathname.includes('monitoring/') ? 'active_menu_element' : 'menu_element')}><span>Setări</span></NavLink>
        </CheckPermission>

        <CheckPermission permissions={['DASHBOARD_VIEW_ALL']}>
          <NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'active_menu_element' : 'menu_element')}><span>Dashboard</span></NavLink>
        </CheckPermission>
        <CheckPermission permissions={['DASHBOARD_VIEW_ALL']}>
          <NavLink to="/rapoarte" className={({ isActive }) => (isActive ? 'active_menu_element' : 'menu_element')}><span>Rapoarte</span></NavLink>
        </CheckPermission>
        <CheckPermission permissions={['SETTING_VIEW_ALL']}>
          <NavLink to="/vessel-tracking" className={({ isActive }) => (isActive ? 'active_menu_element' : 'menu_element')}><span>Vessel Tracking</span></NavLink>
        </CheckPermission>
      </div>
      <div className="flex items-center">
        <UserMenu />
      </div>
    </div>
  );
};

export default MainNavBar;
